import React from "react";
import Button from "@mui/material/Button";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import UserModalComponent from "./userModal";
import CheckIcon from "@mui/icons-material/Check";
import LoaderIndicator from "../../Utility/loading";
import LockResetIcon from "@mui/icons-material/LockReset";
import CloseIcon from "@mui/icons-material/Close";
import { CloudUpload } from "@mui/icons-material";
import { useHistory, useLocation } from "react-router-dom";
import AdminUpdatePasswordModal from "../Models/changePassword";
import { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import DeleteModal from "../Models/Delete/DeleteModal";
import InstaColors, {
  DeleteButton,
  EditButton,
  fontFamily,
  paddingAndMargin,
  paginationstyle,
  reviewScreenButtonWithColor,
  reviewScreenButtonWithOutColor,
  screenHeaderStyle,
  searchBoxStyle,
  UpperLowerText,
  useSharedValue,
} from "../Constants/constants";
import { BASE_URL } from "../../App_Settings/app_settings";
import { formatDate } from "../../Utility/utility";
import { ConditionalPagination } from "../../utils/paginationUtils";
import { getUserIdFromLocalStorage } from "../../API_Endpoints/APIEndpoints";
import UserImportModal from "../UserImport/UserImportModal";

const columns = [
  { field: "firstName", headerName: "FIRST NAME" },
  { field: "lastName", headerName: "LAST NAME" },
  { field: "email", headerName: "EMAIL" },
  { field: "roles", headerName: "ROLES" },
  { field: "createdBy", headerName: "Created By", type: "string" },
  { field: "createdDate", headerName: "Created Date", type: "string" },
  { field: "modifiedBy", headerName: "Modified By", type: "string" },
  { field: "modifiedDate", headerName: "Modified Date", type: "string" },
  { field: "mfaEnabled", headerName: "MFA ENABLED" },
  { field: "isSuspended", headerName: "ACTIVE" },
  { field: "functions", headerName: "" },
];

export default function UserRoleProfile() {
  const location = useLocation();
  const organizationId = location.state?.organizationId;
  const [searchValue, setSearchValue] = React.useState("");
  const [selectDeletedItem, setSelectDeletedItem] = useState(null);
  const [isInputActive, setInputActive] = React.useState(false);
  const [editingData, setEditingData] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  // Reset password modal state
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [resetTargetUser, setResetTargetUser] = useState(null);

  const [title, setTitle] = useState();
  const [healthStatus, setHealthStatus] = useState(null);
  const [requestStatus, setRequestStatus] = useState(null);
  const history = useHistory();
  const [startIndex, setStartIndex] = useState(0); // Initial rows per page value
  const [currentPage, setCurrtPage] = useState(1); // Current page number
  const [endIndex, setEndIndex] = useState(10);
  const { numberOfSelectedRows, updateRowNumberOfPages, defaultUser } = useSharedValue();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  // Excel Import states
  const [showImportModal, setShowImportModal] = useState(false);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [availableBusinessUnits, setAvailableBusinessUnits] = useState([]);
  const [availableOrganizations, setAvailableOrganizations] = useState([]);

  // Reusable function to fetch users data
  const fetchUsersData = async () => {
    setLoading(true);
    const userDataJSON = localStorage.getItem("token");

    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);

      // Use the passed organizationId if available, otherwise use the user's organizationId
      const targetOrgId = organizationId || userData.organizationId;

      try {
        // Fetching data from the backend server
        const response = await fetch(`${BASE_URL}/users/getAllUsers/${targetOrgId}`, {
          headers: {
            Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          console.log("Fetched Users Data:", defaultUser);
          setRows(
            data.filter((item) => {
              // Base condition - not deleted
              if (item.isDeleted) return false;

              // Local search filter (search box on the page)
              const matchesLocalSearch =
                searchValue === "" ||
                item.firstName.toLowerCase().includes(searchValue.toLowerCase()) ||
                item.lastName.toLowerCase().includes(searchValue.toLowerCase()) ||
                item.email.toLowerCase().includes(searchValue.toLowerCase());

              // Global user filter (Search User dropdown) - match by user details
              const matchesGlobalUser =
                !defaultUser ||
                // item.id === defaultUser.id ||
                // item.firstName.toLowerCase().includes(defaultUser.firstName?.toLowerCase() || '') ||
                // item.lastName.toLowerCase().includes(defaultUser.lastName?.toLowerCase() || '') ||
                item.email.toLowerCase().includes(defaultUser.email?.toLowerCase() || "");

              return matchesLocalSearch && matchesGlobalUser;
            })
          );
        } else {
          console.error("Error fetching users:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchUsersData();
  }, [searchValue, organizationId, defaultUser]);

  // Load data for Excel import
  useEffect(() => {
    const loadImportData = async () => {
      try {
        const userDataJSON = localStorage.getItem("token");
        if (!userDataJSON) return;

        const userData = JSON.parse(userDataJSON);
        const token = getUserIdFromLocalStorage().token;

        // Load roles
        const rolesResponse = await fetch(`${BASE_URL}/RolePermission/roles`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (rolesResponse.ok) {
          const rolesData = await rolesResponse.json();
          setAvailableRoles(rolesData);
        }

        // Load business units
        const targetOrgId = organizationId || userData.organizationId;
        const businessUnitsResponse = await fetch(`${BASE_URL}/BusinessUnits/${targetOrgId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (businessUnitsResponse.ok) {
          const businessUnitsData = await businessUnitsResponse.json();
          setAvailableBusinessUnits(businessUnitsData.filter((bu) => !bu.isDeleted));
        }

        // Load organizations (if super admin)
        if (isSuperAdmin) {
          const orgResponse = await fetch(
            `${BASE_URL}/Organization/${userData.userId}/${userData.organizationId}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          if (orgResponse.ok) {
            const orgData = await orgResponse.json();
            setAvailableOrganizations(orgData.filter((org) => org && org.id && org.name));
          }
        }
      } catch (error) {
        console.error("Error loading import data:", error);
      }
    };

    loadImportData();
  }, [organizationId, isSuperAdmin]);

  const handlePageChange = (event, newPage) => {
    setCurrtPage(newPage);
    setStartIndex((parseInt(newPage) - 1) * numberOfSelectedRows);
    setEndIndex((parseInt(newPage) - 1) * numberOfSelectedRows + numberOfSelectedRows);
  };

  let totalPages = Math.ceil(rows.length / rowsPerPage);

  const { isMenuOpen } = useSharedValue();

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setEditingData(null);
    setOpen(false);
    // Remove window.location.reload() - this was causing the page to reload unnecessarily
  };

  const handleEdit = (row) => {
    setEditingData(row);
    handleOpen();
  };

  // Open reset password modal for a specific user
  const handleOpenResetPassword = (row) => {
    setResetTargetUser(row);
    setShowResetPassword(true);
  };

  const handleCloseResetPassword = () => {
    setShowResetPassword(false);
    setResetTargetUser(null);
  };

  // Use same change password endpoint used in profile settings
  const handleSavePassword = (data) => {
    const userDataJSON = localStorage.getItem("token");
    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);
      //api calls to post the data
      return fetch(`${BASE_URL}/users/changepassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
        },
        body: JSON.stringify({
          userId: resetTargetUser.id,
          organizationId: resetTargetUser.organizationId,
          newPassword: data.password,
        }),
      })
        .then((response) => {
          if (response.ok) {
            return response.json(); // Parse JSON if response is OK
          } else {
            alert(`Request failed with status ${response.status}`);
            throw new Error(`Request failed with status ${response.status}`); // Handle non-200 status codes
          }
        })
        .then((data) => {
          if (data) {
            alert("The password has been updated successfully!");
            handleCloseResetPassword();
          }
        });
    } else {
      alert(
        "There seems to be an issue with the change password feature. Could you please log out, log back in, and try again?"
      );
    }
  };

  const handleSave = (newRow) => {
    const userDataJSON = localStorage.getItem("token");

    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);

      // Set processing to true immediately
      setIsProcessing(true);

      if (editingData) {
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === editingData.id
              ? {
                  ...row,
                  ...newRow,
                  firstName: newRow.firstName,
                  lastName: newRow.lastName,
                  mobileNumber: newRow.mobileNumber,
                  modifiedBy: userData.userName,
                  modifiedDate: new Date().toISOString().substring(0, 25),
                }
              : row
          )
        );

        const data = {
          userId: editingData.id,
          firstName: newRow.firstName,
          lastName: newRow.lastName,
          email: newRow.email,
          isActive: newRow.activeValue,
          mobileNumber: newRow.mobileNumber,
          modifiedBy: userData.userName,
          organizationId: isSuperAdmin ? newRow.organizationId : userData.organizationId,
          mfaEnabled: newRow.mfaEnabled || false,
          mfaEmail: newRow.mfaEmail || false,
          mfaMobile: newRow.mfaMobile || false,
          roles: newRow.roles,
          businessUnits: newRow.businessUnits,
        };

        fetch(`${BASE_URL}/Users`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            if (!response.ok) {
              handleClose();
              alert(`Error: Unable to update the user profile. Status: ${response.status}`);
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            response.json();
          })
          .then((data) => {
            setIsProcessing(false);
            alert("User Profile updated successfully");
            handleClose();
            // Refresh the users data to show updated information
            fetchUsersData();
          })
          .catch((error) => {
            setIsProcessing(false);
            console.error("Error adding new value to the database:", error);
          });

        setEditingData(null);
      } else {
        setRows((prevRows) => [
          ...prevRows,
          {
            firstName: newRow.firstName,
            lastName: newRow.lastName,
            mobileNumber: newRow.mobileNumber,
            createdBy: userData.userName,
            createdDate: new Date().toISOString().substring(0, 25),
            modifiedBy: userData.userName,
            modifiedDate: new Date().toISOString().substring(0, 25),
          },
        ]);

        const data = {
          firstName: newRow.firstName,
          lastName: newRow.lastName,
          email: newRow.email,
          password: newRow.password,
          isActive: newRow.activeValue,
          createdBy: userData.userName,
          mobileNumber: newRow.mobileNumber,
          organizationId: isSuperAdmin ? newRow.organizationId : userData.organizationId,
          mfaEnabled: newRow.mfaEnabled || false,
          mfaEmail: newRow.mfaEmail || false,
          mfaMobile: newRow.mfaMobile || false,
          roles: newRow.roles,
          businessUnits: newRow.businessUnits,
        };
        fetch(`${BASE_URL}/Users`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            if (!response.ok) {
              // Show alert for non-200 responses
              alert(`Error: Unable to create the user profile. Status: ${response.status}`);
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            response.json();
          })
          .then((data) => {
            setIsProcessing(false);
            alert("New user profile created successfully");
            handleClose();
            // Refresh the users data to show the new user
            fetchUsersData();
          })

          .catch((error) => {
            setIsProcessing(false);
            console.error("Error adding new value to the database:", error);
          });
      }
    }
  };

  useEffect(() => async () => {
    // Fetch users based on organization ID
    const response = await fetch(
      `${BASE_URL}/users/${getUserIdFromLocalStorage().userId}/${getUserIdFromLocalStorage().organizationId}`,
      {
        headers: {
          Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
        },
      }
    );
    if (response.ok) {
      const user = await response.json();

      if (user) {
        if (user.isSuperAdmin) {
          setIsSuperAdmin(user.isSuperAdmin);
        }
      } else {
      }
    } else {
      console.error("Failed to fetch users:", response.statusText);
    }
  });

  // Import modal handlers
  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const handleImportClose = () => {
    setShowImportModal(false);
  };

  const handleImportComplete = (summary) => {
    setShowImportModal(false);
    // Refresh the users data to show imported users
    fetchUsersData();

    // Show detailed message based on results
    if (summary.errorCount > 0) {
      alert(
        `Import completed! ${summary.successCount} users created successfully, ${summary.errorCount} failed.`
      );
    } else {
      alert(`Import completed! ${summary.successCount} users created successfully.`);
    }
  };

  const handleDelete = () => {
    setIsPopupOpen(false);

    // Update the user's isActive status to false
    const userDataJSON = localStorage.getItem("token");
    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);

      // Find the selected user's complete data
      const selectedUser = rows.find((row) => row.id === selectDeletedItem);

      // Transform roles to match expected format - use userRoles instead of roles
      const transformedRoles =
        selectedUser.userRoles?.map((role) => ({
          roleId: role.roleId || role.id,
        })) || [];

      // Use the exact same structure as the working update function
      const data = {
        userId: selectDeletedItem,
        firstName: selectedUser.firstName,
        lastName: selectedUser.lastName,
        email: selectedUser.email,
        isActive: false, // This is the only difference - set to false for delete
        isDeleted: true,
        mobileNumber: selectedUser.mobileNumber,
        modifiedBy: userData.userName,
        organizationId: selectedUser.organizationId || userData.organizationId,
        roles: transformedRoles,
        businessUnits:
          selectedUser.businessUnits?.map((bu) => ({
            businessUnitId: bu.id || bu.businessUnitId,
            isDefault: bu.isDefault || false,
          })) || [],
      };

      console.log("🚨 DELETE USER PAYLOAD:", JSON.stringify(data, null, 2));

      fetch(`${BASE_URL}/Users`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
        },
        body: JSON.stringify(data),
      })
        .then(async (response) => {
          if (!response.ok) {
            // Try to get the error message from the response
            let errorMessage = `HTTP error! Status: ${response.status}`;
            try {
              const errorText = await response.text();
              console.log("🚨 Backend Error Response:", errorText);
              errorMessage = `Error: Unable to deactivate the user. Status: ${response.status}. Message: ${errorText}`;
            } catch (e) {
              console.log("Could not parse error response");
            }
            alert(errorMessage);
            throw new Error(errorMessage);
          }

          // Try to parse as JSON, if it fails, return the text
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.includes("application/json")) {
            return response.json();
          } else {
            const textResponse = await response.text();
            console.log("🚨 Non-JSON Response:", textResponse);
            return { message: textResponse };
          }
        })
        .then(() => {
          // Update the local state to remove the user from the list
          setRows((prevRows) => prevRows.filter((row) => row.id !== selectDeletedItem));
          const updatedRows = rows.filter((row) => row.id !== selectDeletedItem);

          // Calculate the new total pages
          totalPages = Math.ceil(updatedRows.length / rowsPerPage);

          // Determine if the current page should be adjusted
          let newCurrentPage = currentPage;
          if (currentPage > totalPages) {
            newCurrentPage = totalPages;
          } else if (currentPage === totalPages && updatedRows.length % rowsPerPage === 0) {
            newCurrentPage = currentPage - 1 > 0 ? currentPage - 1 : 1;
          }

          // Update the current page
          setCurrtPage(newCurrentPage);

          // Calculate and update the start and end indices
          const startIndex = (newCurrentPage - 1) * rowsPerPage;
          let endIndex = startIndex + rowsPerPage;
          endIndex = endIndex > updatedRows.length ? updatedRows.length : endIndex;

          setStartIndex(startIndex);
          setEndIndex(endIndex);

          alert("User has been deleted successfully");
          // Refresh the users data to ensure consistency
          fetchUsersData();
        })
        .catch((error) => {
          console.error("Error deactivating user:", error);
        });
    }
  };

  const filteredRows = rows.filter(
    (row) =>
      (row.firstName?.toLowerCase() || "").includes(searchValue.toLowerCase()) ||
      (row.lastName?.toLowerCase() || "").includes(searchValue.toLowerCase()) ||
      (row.email?.toLowerCase() || "").includes(searchValue.toLowerCase())
  );
  return (
    <div style={screenHeaderStyle(isMenuOpen)}>
      <div
        style={{
          marginTop: paddingAndMargin.headerTopHeight,
          marginBottom: paddingAndMargin.headerBelowHeight,
          backgroundColor: "transparent",
          marginRight: 30,
          marginLeft: 30,
        }}
      >
        <InputBase
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onFocus={() => setInputActive(true)}
          onBlur={() => setInputActive(false)}
          style={searchBoxStyle}
          inputProps={{ "aria-label": "Entity Search", style: { padding: "0 8px" } }}
          placeholder="Search Users"
          endAdornment={
            isInputActive || searchValue ? (
              <CloseIcon
                style={{ cursor: "pointer", color: "#2aa7e0" }}
                onMouseDown={(e) => {
                  e.preventDefault(); // Prevent input blur
                  setSearchValue("");
                  setInputActive(false);
                }}
              />
            ) : (
              <SearchIcon style={{ color: "#2aa7e0" }} />
            )
          }
        />
        {!isSuperAdmin && (
          <Button
            onClick={handleImportClick}
            style={{
              ...reviewScreenButtonWithColor(180, "right"),
              marginRight: "10px",
              backgroundColor: "#4caf50",
            }}
            variant="contained"
          >
            <CloudUpload style={{ marginRight: "8px", fontSize: "18px" }} />
            Import Users
          </Button>
        )}
        <Button
          onClick={() => {
            setOpen(true);
            setEditingData("");
            setTitle("Create New User Profile");
          }}
          style={reviewScreenButtonWithColor(180, "right")}
          variant="contained"
        >
          Add New User
        </Button>
      </div>

      {/* Column Titles */}
      <div class="columntitlesRowStyle">
        {/* <div style={{ paddingRight: '10px' }}>
          <Checkbox disabled size="small" style={{ color: InstaColors.checkboxColor }} />
        </div> */}
        {columns.map((column) => (
          <div
            key={column.field}
            style={{
              flex: 1, // Equal spacing for each column
              fontFamily: fontFamily,
              fontWeight: 400,
              fontSize: 13,
              whiteSpace: "nowrap",
              color: "white",
              textOverflow: "ellipsis",
              textTransform: "none",
            }}
          >
            <UpperLowerText text={column.headerName} />
          </div>
        ))}
      </div>
      {loading ? (
        <div
          style={{
            textAlign: "center",
            fontSize: "18px",
            color: "#555",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LoaderIndicator />
        </div>
      ) : rows.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            fontSize: "18px",
            color: "#555",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          There are no users available.
        </div>
      ) : (
        <div>
          {/* Row Data */}
          {(isInputActive ? filteredRows : rows).slice(startIndex, endIndex).map((row) => (
            <div
              key={row.fileImportId}
              style={{
                color: InstaColors.fontColor,
                fontSize: 12,
                paddingLeft: 10,
                paddingRight: 10,
                whiteSpace: "nowrap",
                backgroundColor: "white",
                display: "flex",
                alignItems: "center",
                marginRight: 40,
                marginLeft: 40,
                height: 34,
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              {/* <div style={{ paddingRight: '10px', }}>
              <Checkbox size="small" title="Select" onChange={() => { }} style={{ color: '#2aa7e0' }} />
            </div> */}
              {columns.map((column) => (
                <div
                  title={
                    column.headerName === "Modified Date" && row[column.field] != null
                      ? formatDate(row[column.field])
                      : column.headerName === "Created Date"
                        ? formatDate(row[column.field])
                        : row[column.field]
                  }
                  key={column.field}
                  style={{
                    flex: 1,
                    fontFamily: fontFamily,
                    fontWeight: 300,
                    fontSize: 12,
                    whiteSpace: "nowrap",
                    color: "#424242",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    textTransform: "none",
                  }}
                >
                  {column.field === "isSystemAdministrator" ||
                  column.field === "isSuspended" ||
                  column.field === "isApprover" ? (
                    <div
                      style={{
                        display: "flex",
                        paddingLeft: column.field === "isSuspended" ? 15 : 0,
                      }}
                    >
                      {row[column.field] == false && <CheckIcon style={{ color: "#2aa7e0" }} />}
                    </div>
                  ) : column.field === "mfaEnabled" ? (
                    <div style={{ display: "flex", alignItems: "center", paddingLeft: 15 }}>
                      {row.mfaEnabled ? (
                        <span
                          style={{
                            backgroundColor: "#E8F5E9",
                            padding: "2px 10px",
                            borderRadius: "12px",
                            fontSize: "11px",
                            color: "#2E7D32",
                            fontWeight: 500,
                          }}
                        >
                          ✓ Enabled
                        </span>
                      ) : (
                        <span
                          style={{
                            backgroundColor: "#FFEBEE",
                            padding: "2px 10px",
                            borderRadius: "12px",
                            fontSize: "11px",
                            color: "#C62828",
                            fontWeight: 500,
                          }}
                        >
                          Disabled
                        </span>
                      )}
                    </div>
                  ) : column.field === "roles" ? (
                    <div style={{ display: "flex", gap: "4px" }}>
                      {row.userRoles?.map((role, index) => (
                        <span
                          key={index}
                          style={{
                            backgroundColor: "#E3F2FD",
                            padding: "2px 8px",
                            borderRadius: "4px",
                            fontSize: "11px",
                            color: "#1976D2",
                          }}
                        >
                          {role.name}
                        </span>
                      ))}
                    </div>
                  ) : column.field === "functions" ? (
                    <div style={{ display: "flex", alignItems: "flex-end" }}>
                      <div style={{ marginRight: "auto" }}></div>
                      <EditButton
                        onClick={() => {
                          handleEdit(row);
                          setTitle("Edit User Profile");
                        }}
                      />
                      <IconButton
                        title="Reset password"
                        onClick={() => handleOpenResetPassword(row)}
                        style={{
                          color: "#2aa7e0",
                          marginLeft: "10px",
                          marginBottom: "0px",
                          width: "20px",
                          height: "20px",
                        }}
                      >
                        <LockResetIcon style={{ color: "#2aa7e0" }} />
                      </IconButton>
                      <DeleteButton
                        onClick={() => {
                          setIsPopupOpen(true);
                          setSelectDeletedItem(row.id);
                        }}
                      />
                    </div>
                  ) : column.headerName === "Modified Date" && row[column.field] != null ? (
                    formatDate(row[column.field])
                  ) : column.headerName === "Created Date" ? (
                    formatDate(row[column.field])
                  ) : (
                    row[column.field]
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
      {/* Delete Confirmation Modal */}
      <DeleteModal
        open={isPopupOpen}
        isDeleting={false}
        onClose={() => setIsPopupOpen(false)}
        onDelete={handleDelete}
        deleteButtonStyle={reviewScreenButtonWithColor(100)}
        cancelButtonStyle={reviewScreenButtonWithOutColor(100)}
      />

      {/* User Modal Component */}
      <UserModalComponent
        show={open}
        handleClose={() => setOpen(false)}
        onSave={handleSave}
        handleEdit={editingData}
        title={title}
        isLoading={loading}
        isSuperAdmin={isSuperAdmin}
      />

      {/* Reset Password Modal (Admin) */}
      <AdminUpdatePasswordModal
        show={showResetPassword}
        handleClose={handleCloseResetPassword}
        onSave={handleSavePassword}
        editingData={resetTargetUser}
      />

      {/* Global Loader - shows when modal is closed and processing is true */}
      {!open && isProcessing && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <LoaderIndicator />
            <span style={{ fontFamily: fontFamily, color: "#2aa7e0" }}>Processing...</span>
          </div>
        </div>
      )}

      <ConditionalPagination
        itemCount={rows.length}
        itemsPerPage={rowsPerPage}
        threshold={rowsPerPage}
        paginationProps={{
          page: currentPage,
          onChange: handlePageChange,
          style: paginationstyle,
        }}
      />

      {/* Excel Import Modal */}
      {!isSuperAdmin && (
        <UserImportModal
          show={showImportModal}
          onClose={handleImportClose}
          onImportComplete={handleImportComplete}
          availableRoles={availableRoles}
          availableBusinessUnits={availableBusinessUnits}
          availableOrganizations={availableOrganizations}
          currentUserOrganizationId={organizationId}
          isSuperAdmin={isSuperAdmin}
        />
      )}
    </div>
  );
}
